import React from "react";

function Dealersanddistributors() {
  return (
    <div className="container">
      <div className="header">
        <h3>Dealer/Distributor Application</h3>
        <p>
          Founded by Mr. Sanjay Gupta, a chartered Accountant and company
          Secretary by qualifications, STPL is one of the most renowned
          businesses in North India.
          <br />
          <br />
          Spinofftechno Park Ltd. Is a ISO and BIS certified manufacturing
          company which focuses on customer satisfaction through delivering
          consistent high quality and value for money. Our product range
          includes inverters, Lithium batteries, LED Lights and sheet metal
          Products. Our two manufacturing units are situated in Mohali and
          Rajpura (Punjab).
          <br />
          <br />
          This is the only official website for distributorship enquiries with
          STPL and we don’t have any other partner website for any queries
          regarding allotment distributorship. For applying for the
          distributorship with STPL Please apply in the applicable category of
          your business setup as under.
        </p>
        <p>Please choose a category to proceed with your application.</p>
      </div>

    </div>
  );
}

export default Dealersanddistributors;
